/**
 * SearchTrendingData 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'
import type { SearchTrending } from './search_trending'

/**
 * SearchTrendingData
 */
export interface SearchTrendingData {
  /** 搜索趋势ID */
  id?: string
  /** 搜索趋势信息 */
  info?: SearchTrending
}

/**
 * SearchTrendingData Schema
 */
export const SearchTrendingDataSchema: SchemaDefinition = {
  properties: {
    id: {
      description: '搜索趋势ID',
      format: 'string',
      type: 'string',
      label: '搜索趋势ID',
    },
    info: {
      $ref: 'SearchTrending',
      description: '搜索趋势信息',
      label: '搜索趋势信息',
    },
  },
  type: 'object',
}
